import React from 'react';
import Page from '../components/Page';
import { Redirect } from 'react-router';
import StorageService from '../services/StorageService';
import {
  Button,
  Card,
  CardBody,
  Col,
  Row,
  Table,
  Modal,
  Input,
  Form,
} from 'reactstrap';
import {
  MdDone,
  MdClear,
  MdCreate,
  MdFilterList,
  MdDateRange,
} from 'react-icons/md';
import axios from 'axios';
import LocationDetails from '../components/LocationDetails';
import Moment from 'react-moment';

class ActivityPage2 extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      modal: false,
      date: '',
      filterKey: '',
      activityList: [],
      redirect: false,
      columnCount: 0,
      columnName: [],
      activityId: '',
    };
  }

  getActivityList = date => {
    const user = StorageService.getSession('user_info');
    const data = {
      sitekey: this.props.match.params.id,
      date: date,
    };

    axios
      .post('https://zoidapi.pseudoscops.com:3005/v1/extapi/therma/data', data)
      .then(response => {
        const result = response.data;

        if (result.error == true && result.message != 'Success') {
          alert(result.message);
          return;
        }
        let count = 0;

        let columns = [];
        if (result.data.length) {
          for (let i of result.data) {
            let total = Object.keys(JSON.parse(i.activity_data)).length;
            if (total > count) {
              count = total;
              for (var prop in JSON.parse(i.activity_data)) {
                let lcprop = prop.toLowerCase();
                if (
                  !columns.includes(lcprop) &&
                  (lcprop === 'mode' ||
                    lcprop === 'name' ||
                    lcprop === 'phone' ||
                    lcprop === 'email' ||
                    lcprop === 'id' ||
                    lcprop === 'temperature')
                ) {
                  columns.push(lcprop);
                }
              }
            }
          }
        }

        if (count > 6) {
          count = 6;
        }

        console.log(columns);

        this.setState({
          activityList: result.data,
          columnCount: count,
          columnName: columns.sort(),
        });
      })
      .catch(error => {
        alert(error);
      });
  };

  changeHandler = event => {
    this.setState({
      date: event.target.value,
    });

    this.getActivityList(event.target.value);
  };

  changeDropdownHandler = event => {
    this.setState({
      [event.target.name]: event.target.value,
    });

    this.getActivityList(this.state.date, event.target.value);
  };

  toggle = id => () => {
    return this.setState({
      modal: !this.state.modal,
      activityId: id,
    });
  };

  getCurrentDate(date) {
    let newDate = '';
    if (date === null) {
      newDate = new Date();
    } else {
      newDate = new Date(date);
    }

    let day = newDate.getUTCDate();
    let month = newDate.getUTCMonth() + 1;
    let year = newDate.getUTCFullYear();

    let hour = newDate.getUTCHours();
    let minute = newDate.getUTCMinutes();

    if (month < 10) month = '0' + month;
    if (day < 10) day = '0' + day;

    if (hour < 10) hour = '0' + hour;
    if (minute < 10) minute = '0' + minute;

    return year + '-' + month + '-' + day + ' ' + hour + ':' + minute;
  }

  setDate() {
    let newDate = new Date();
    let day = newDate.getDate();
    let month = newDate.getMonth() + 1;
    let year = newDate.getFullYear();

    if (month < 10) month = '0' + month;
    if (day < 10) day = '0' + day;

    this.setState({
      date: year + '-' + month + '-' + day,
    });

    return year + '-' + month + '-' + day;
  }

  componentDidMount() {
    if (StorageService.getSession('selected_org') === null) {
      this.setState({
        redirect: true,
      });
    } else {
      this.setDate();
      this.getActivityList(this.setDate());
      //this.getActivityList(this.getCurrentDate(null));
    }
  }

  render() {
    const { columnCount } = this.state;
    if (this.state.redirect) {
      return <Redirect to="/" />;
    }

    return (
      <Page
        className="ActivityPage"
        title="Activity"
        breadcrumbs={[
          { name: 'Site', active: false, path: '/site' },
          { name: 'Activity', active: true, path: '/site/:id/activity' },
        ]}
      >
        <Row>
          <Col xl={12} lg={12} md={12}>
            <Card>
              <CardBody>
                <Form className="AuthForm mb-4">
                  <Row className="justify-content-between">
                    <Col md={3}>
                      <div className="d-flex align-items-center">
                        <MdDateRange className="ps-input-icon" />
                        <Input
                          type="date"
                          name="date"
                          value={this.state.date}
                          onChange={this.changeHandler}
                        />
                      </div>
                    </Col>
                  </Row>
                </Form>

                <Table responsive className="ps-table ps-tb-horizontal">
                  <thead>
                    <tr>
                      <th>Location</th>
                      <th>Date/Time</th>
                      {/* {this.state.columnName.length > 0 &&
                        this.state.columnName.map((item, index) => {
                          return (
                            <th key={index}>
                              {item[0].toUpperCase() + item.slice(1)}
                            </th>
                          );
                        })} */}
                      <th>Email</th>
                      <th>ID</th>
                      <th>Mode</th>
                      <th>Name</th>
                      <th>Phone</th>
                      <th>Temperature</th>
                      <th>Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    {this.state.activityList.length < 1 && (
                      <tr>
                        <td colSpan="9">
                          <div className="ps-empty-data">
                            <div className="empty-content">
                              <MdCreate />
                              <h4>No data to show</h4>
                            </div>
                          </div>
                        </td>
                      </tr>
                    )}

                    {this.state.activityList.length > 0 &&
                      this.state.activityList.map((item, index) => {
                        return (
                          <React.Fragment key={index}>
                            <tr>
                              <td>{item.name}</td>
                              <td>
                                {/* <Moment format="YYYY-MM-DD HH:mm">
                                  {item.register_dt}
                                </Moment> */}
                                {this.getCurrentDate(item.localdt)}
                              </td>
                              {'email' in JSON.parse(item.activity_data) ? (
                                <td>
                                  {JSON.parse(item.activity_data)['email']}
                                </td>
                              ) : (
                                <td className="td-none"></td>
                              )}

                              {'ID' in JSON.parse(item.activity_data) ? (
                                <td>{JSON.parse(item.activity_data)['ID']}</td>
                              ) : (
                                <td className="td-none"></td>
                              )}

                              {'mode' in JSON.parse(item.activity_data) ? (
                                <td>
                                  {JSON.parse(item.activity_data)['mode']}
                                </td>
                              ) : (
                                <td className="td-none"></td>
                              )}

                              {'Name' in JSON.parse(item.activity_data) ? (
                                <td>
                                  {JSON.parse(item.activity_data)['Name']}
                                </td>
                              ) : (
                                <td className="td-none"></td>
                              )}

                              {'phone' in JSON.parse(item.activity_data) ? (
                                <td>
                                  {JSON.parse(item.activity_data)['phone']}
                                </td>
                              ) : (
                                <td className="td-none"></td>
                              )}

                              {'Temperature' in
                              JSON.parse(item.activity_data) ? (
                                <td>
                                  {
                                    JSON.parse(item.activity_data)[
                                      'Temperature'
                                    ]
                                  }
                                </td>
                              ) : (
                                <td className="td-none"></td>
                              )}

                              {/* {Object.keys(JSON.parse(item.activity_data)).map(
                                function (key, index) {
                                  return (
                                    index < 6 && (
                                      <React.Fragment key={index}>
                                        <td>
                                          {JSON.parse(item.activity_data)[
                                            key
                                          ] === null
                                            ? 'No'
                                            : JSON.parse(item.activity_data)[
                                                key
                                              ]}
                                        </td>
                                      </React.Fragment>
                                    )
                                  );
                                },
                              )}
                              {Object.keys(JSON.parse(item.activity_data))
                                .length < columnCount &&
                                Array.from(
                                  Array(
                                    columnCount -
                                      Object.keys(
                                        JSON.parse(item.activity_data),
                                      ).length,
                                  ),
                                  (e, i) => {
                                    return (
                                      <td key={i} className="td-none"></td>
                                    );
                                  },
                                )} */}
                              <td>
                                <div className="ps-action-button">
                                  <Button
                                    className="theme-button theme-button-primary-light"
                                    onClick={this.toggle(item.activity_data_id)}
                                  >
                                    View
                                  </Button>
                                </div>
                              </td>
                            </tr>
                          </React.Fragment>
                        );
                      })}
                  </tbody>
                </Table>
              </CardBody>
            </Card>
          </Col>
        </Row>

        <Modal
          isOpen={this.state.modal}
          toggle={this.toggle()}
          className={this.props.className}
          centered
          style={{ minWidth: '700px', fontSize: '0.85rem' }}
        >
          <LocationDetails
            history={this.props.history}
            onToggleModal={this.toggle}
            data={this.state}
          />
        </Modal>
      </Page>
    );
  }
}
export default ActivityPage2;
